import React, { useState, useContext, useEffect, useMemo } from "react";
import { Box, Typography, Button, Paper, Checkbox } from "@mui/material";
import Grid from '@mui/material/Grid2';

import { useNavigate } from 'react-router-dom';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ModalMassive from "../GeneralComponents/ModalMassive";

import Stack from "@mui/material/Stack";
import GeneralContext from "../GeneralContext/GeneralContext";
import InputFilter from "../GeneralComponents/InputFilter";
import InputChipSelect from "../GeneralComponents/InputChipSelect";
import axios from "../../api/axios";

import PageBody from "../GeneralComponents/PageBody";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Collapse from "@mui/material/Collapse";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { CircularProgress } from '@mui/material';
import ListStepper from "../GeneralComponents/ListStepper";
import ListEmpty from "../GeneralComponents/ListEmpty";
import PageButtonWhite from "../GeneralComponents/PageButtonWhite";
import * as XLSX from "xlsx";


import {NO_EES, NO_EES_TEMP, NO_SUBTEL, NO_MINEDUC, REJECTED, APROVED, ROL_ADMIN, ROL_OP_ADMIN, ROL_REP_EES, ROL_REP_EES_TEMP, ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL, ROL_CON_MINEDUC, ROL_MINEDUC_ADMIN} from "../../Constants/Constants";
import dayjs from "dayjs";
// Si usas dayjs sin plugin de parsing estricto añade esto:
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

let g_start_date = new Date();
g_start_date.setDate(g_start_date.getDate() - 7);

const formatPeriodos = (arr = []) => {
  if (arr.length <= 2) return arr.join(", ");
  return `${arr.slice(0, 2).join(", ")} y ${arr.length - 2} más`;
};

const columns = [
  {
    id: "checkbox",
    label: "",
    width: "5%",
    minWidth: "50px",
    align: "center",
  },
{ id: "folio", label: "ID folio", width: "12%", minWidth: "80px"},
  { id: "periodo_creacion", label: "Periodo creación", width: "12%", minWidth: "80px"},
  { id: "periodos", label: "Periodos Afectación", width: "12%", minWidth: "110px",
  valueFormatter: ({ value }) => formatPeriodos(value)},
  { id: "rut_emisor", label: "Rut Emisor", width: "12%", minWidth: "120px" },
  {
    id: "estado_resumen",
    label: "Estado",
    width: "16%",
    minWidth: "140px",
    align: "left",
  },
  {
    id: "firma",
    label: "Firma",
    width: "12%",
    minWidth: "100px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "cerrado_por",
    label: "Cerrado por",
    width: "12%",
    minWidth: "100px",
    align: "left"
  },
  {
    id: "revisar",
    label: "Revisar documento",
    width: "80px",
    minWidth: "80px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "revisar_no_sub",
    label: "Revisar documento",
    width: "80px",
    minWidth: "80px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "temporal",
    label: "Representante Temporal",
    width: "12%",
    minWidth: "100px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "revisar_mineduc",
    label: "Revisar documento",
    width: "80px",
    minWidth: "80px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "rbd",
    label: "RBD",
    width: "12%",
    minWidth: "100px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "tipo_compuesto",
    label: "Tipo",
    width: "12%",
    minWidth: "100px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "detalle",
    label: "Detalle Documento",
    width: "12%",
    minWidth: "100px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "sobrescribir",
    label: "Recrear Documento",
    width: "12%",
    minWidth: "80px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "ruta_url",
    label: "Documento",
    width: "10%",
    minWidth: "100px",
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "operador",
    label: "Operador",
    width: "12%",
    minWidth: "100px",
    align: "left",
  },
];




export default function ContingenciasList({ prefilter = false }) {
  const [rows, setRows] = useState([]);
  const { includeRol, pageTitle, setPageTitle, userSesion } = useContext(GeneralContext);
  const [filters, setFilters] = useState({});
  const [tableData, setTableData] = useState(rows);
  const [loadingTable, setLoadingTable] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [filteredColumns, setFilteredColumns] = useState([]);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [selected, setSelected] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [selectedPeriodo, setSelectedPeriodo] = useState(null)
  const [selectedPeriodoData, setSelectedPeriodoData] = useState([]);
  const navigate = useNavigate();

  const periodoAfectacionData = useMemo(() => {
    // genera [{ periodo: 'YYYY-MM' }, ...] con todos los meses de afectación de todos los rows
    const flat = rows.flatMap((r) => (r.periodos || []).map((p) => ({ periodo: p })));

    // único y ordenado ('YYYY-MM' ordena bien como string)
    const uniq = Array.from(new Set(flat.map((x) => x.periodo)))
      .sort()
      .map((p) => ({ periodo: p }));

    return uniq;
  }, [rows]);

  const [action, setAction] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = (action) => {setAction(action); setOpen(true);}
  const handleClose = (fromModal, successfulCount) =>{ setOpen(false); fetchData(fromModal, successfulCount)}

  const firmasPendientes = [ NO_EES, NO_EES_TEMP, NO_SUBTEL, NO_MINEDUC ];

  const rolesFirma = {
    EES: [ NO_EES, NO_EES_TEMP ],
    SUBTEL: [ NO_SUBTEL ],
    MINEDUC: [ NO_MINEDUC ],
  };

  const hasActionableSelection = React.useMemo(() => {
    const firmasPendientes = [ NO_EES, NO_EES_TEMP, NO_SUBTEL, NO_MINEDUC ];
  if (!selected?.length) return false;
  const selectedRows = tableData.filter(r => selected.includes(r.id));
  return selectedRows.some(r => firmasPendientes.includes(r.estado));
}, [selected, tableData]);

function getSignatureText(currentState) {

    let inst = "FAS";
    if (includeRol([ROL_REP_EES, ROL_REP_EES_TEMP])) {
        inst = "EES";
    } else if (includeRol([ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL])) {
        inst = "SUBTEL";
    } else if (includeRol([ROL_MINEDUC_ADMIN, ROL_CON_MINEDUC])) {
        inst = "MINEDUC";
    }

    const currentStep = firmasPendientes.indexOf(currentState);

    const userSteps = rolesFirma[inst] || [];

    const userStepsIndex = firmasPendientes.findIndex((etapa) =>
        userSteps.includes(etapa)
    );
    if (userSteps.includes(currentState)) {
        return "Firmar";
    }

    if (userStepsIndex > currentStep) {
        return "Firmar";
    }
    return "Firmado";
}

  const canSign = (estado) => {
    if (
      (estado === NO_EES || estado === NO_EES_TEMP) &&
      includeRol([ROL_REP_EES, ROL_REP_EES_TEMP])
    ) {
      return true;
    } else if (
      estado === NO_SUBTEL &&
      includeRol([ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL])
    ) {
      return true;
    } else if (
      estado === NO_MINEDUC &&
      includeRol([ROL_MINEDUC_ADMIN, ROL_CON_MINEDUC])
    ) {
      return true;
    }

    return false;
  };

  const downloadXLS = () => {
  //const selectedRows = tableData.filter((row) => selected.includes(row.id));

  const selectedRows = selectedPeriodoData;
  if (selectedRows.length === 0) {
    alert("No hay filas seleccionadas para descargar.");
    return;
  }

  const filteredData = selectedRows.map((row) => ({
    rbd: row.rbd,
    folio: row.folio,
    periodos: row.periodos.join(", "),
    tipo_contingencia: row.tipo_compuesto,
    id_operador: row.id_operador,
    operador: row.operador,
    rut_emisor: row.rut_emisor,
    id_zona: row.id_zona,
    estado: row.estado,
    cerrado_por: row.cerrado_por,
    rol: row.rol_cerrado_por,
    estado_resumen: row.estado_resumen,
    fecha_creacion: row.fecha_creacion,
    fecha_inicio: row.tipo_contingencia === "PROGRAMADA" ? row.programada_inicio_contingencia+"T"+row.programada_hora_inicio : row.especifica_fecha_hora_ocurrencia ,
    fecha_termino: row.tipo_contingencia === "PROGRAMADA" ? row.programada_fin_contingencia+"T"+row.programada_hora_termino : row.especifica_fecha_hora_resolucion ,
    descripcion: row.tipo_contingencia === "PROGRAMADA" ? row.programada_descripcion : row.especifica_descripcion_falla,
    link_documento: row.ruta_url,
    temporal: row.temporal,
  }));




    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Tabla");
    XLSX.writeFile(workbook, "tabla.xlsx");
  };


    const downloadPDF = (url) => {
      setLoadingPDF(true);
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/pdf',
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.blob();
            })
            .then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');

                a.href = blobUrl;
                a.download = 'download.pdf';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(blobUrl);
            })
            .catch((error) => {setLoadingPDF(false); console.error('Error al descargar el archivo:', error); window.open(url, '_blank'); });
    };

    const downloadZip = async () => {
      try {
        if (selected.length === 0){
          return
        }
        setDownloadLoader(true);
        const now = new Date();
        const timestamp = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}_${String(now.getHours()).padStart(2, "0")}-${String(now.getMinutes()).padStart(2, "0")}-${String(now.getSeconds()).padStart(2, "0")}`;
        
        const response = await axios.downloadDocuments("contingencias", selected);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `contingencias_${timestamp}.zip`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    } catch (error) {
        console.error("Error al descargar documentos:", error);
    }
    setDownloadLoader(false);
  };


  const parseDate = (str) =>
  str ? dayjs(str, ["YYYY-MM-DD", "YYYY/MM/DD", "YYYY-MM-DDTHH:mm:ss"]).startOf("day") : null;

/** Devuelve ['YYYY-MM', …] para todos los meses entre start y end (ambos inclusive). */
const monthsBetween = (startStr, endStr) => {
  const out = [];
  let start = parseDate(startStr)?.startOf("month");
  const end = parseDate(endStr)?.startOf("month");
  if (!start || !end) return out;

  while (start.isSame(end) || start.isBefore(end)) {
    out.push(start.format("YYYY-MM"));
    start = start.add(1, "month");
  }
  return out;
};


  const fetchData = async (fromModal : boolean = false, count: number = 0) => {
    if(fromModal && count === 0){
      return;
    }
    setLoadingTable(true);
    axios
  .getContingenciasData(userSesion.id)
  .then((response) => {
    const modifiedData = response.data
      // Filtrado opcional
      .filter((row) => !prefilter || row.estado === "Pendiente")
      // Transformación
      .map((row) => {
        /* Determinar fechas de inicio y fin según el tipo de contingencia */
        const isProgramada = row.tipo_contingencia === "PROGRAMADA";

        const fechaInicio = isProgramada
          ? row.programada_inicio_contingencia          // 'YYYY-MM-DD' o 'YYYY/MM/DD'
          : row.especifica_fecha_hora_ocurrencia;       // 'YYYY-MM-DDTHH:mm:ss'

        const fechaFin = isProgramada
          ? row.programada_fin_contingencia
          : row.especifica_fecha_hora_resolucion;

        const origen = (row.especifica_origen_falla === "Falla interna al adjudicatario" || row.tipo_contingencia === "PROGRAMADA"  ) ? "Interna" : "Externa";

          const nombres = row.datos?.ees_temporal_manager_nombres ?? "";
          const apellidos = row.datos?.ees_temporal_manager_apellidos ?? "";

          const nombreCompleto = `${nombres} ${apellidos}`.trim();
        return {
          ...row,
          periodo_creacion: row.fecha_creacion.slice(0, 7), 
          rbd: row.rbd || "-", 
          periodo: row.fecha_creacion.slice(0, 7), 
          periodos: monthsBetween(fechaInicio, fechaFin),
          fecha: row.fecha_creacion.split("T")[0],
          estado_resumen:
            row.estado !== APROVED && row.estado !== REJECTED
              ? "En Proceso"
              : row.estado,
          puede_firmar: canSign(row.estado),
          firma: "",
          extension: row.tipo_contingencia === "ZONAL" ? "Por Zona" : "Por RBD",
          temporal: nombreCompleto !== "" ? nombreCompleto : " Sin Representante Temporal",
          origen: origen,
          checkbox: "",
          detalle: "",
          revisar: "",
          revisar_no_sub: "",
          revisar_mineduc: "",
          cerrado_por: row.cerrado_por ? row.cerrado_por : "No cerrado",
          tipo_compuesto:
            row.tipo_contingencia === "ZONAL"
              ? "ZONAL"
              : row.tipo_contingencia === "PROGRAMADA"
              ? "PROGRAMADA"
              : origen.toUpperCase(),
          folio: String(row.id).padStart(8, "0"),
        };
      });

    const visibleData = includeRol([ROL_REP_EES, ROL_REP_EES_TEMP])
      ? modifiedData.filter((row) => row.origen === "Interna")
      : modifiedData;

    setRows(visibleData);
    setTableData(visibleData);
    if (count !== 0){
      applyFilters(visibleData);
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {
    setLoadingTable(false);
  });

    if (
      includeRol([ROL_REP_EES, ROL_REP_EES_TEMP ])
    ) {
      const columnOrder = [
            "checkbox",
            "periodos",
            "periodo",
            "rbd",
            "folio",
            "operador",
            "tipo_compuesto",
            "temporal",
            "estado_resumen",
            "revisar_no_sub",
            "ruta_url",
    ];

    setFilteredColumns(
      columnOrder
        .map((id) => columns.find((column) => column.id === id))
        .filter(Boolean)
    );
    } else if (includeRol([ROL_MINEDUC_ADMIN])) {
       const columnOrder = [
            "checkbox",
            "periodos",
            "periodo",
            "folio",
            "operador",
            "origen",
            "tipo_compuesto",
            "estado_resumen",
            "revisar_mineduc",
            "ruta_url",
            "cerrado_por"
    ];

    setFilteredColumns(
      columnOrder
        .map((id) => columns.find((column) => column.id === id))
        .filter(Boolean)
    );

    } else if (includeRol([ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL])) {
       const columnOrder = [
            "checkbox",
            "periodos",
            "periodo",
            "folio",
            "operador",
            "origen",
            "tipo_compuesto",
            "estado_resumen",
            "revisar",
            "ruta_url",
            "cerrado_por"
    ];

    setFilteredColumns(
      columnOrder
        .map((id) => columns.find((column) => column.id === id))
        .filter(Boolean)
    );

    } else if (includeRol([ROL_OP_ADMIN])) {
       const columnOrder = [
            "checkbox",
            "periodos",
            "periodo",
            "folio",
            "origen",
            "tipo_compuesto",
            "estado_resumen",
            "firma",
            "detalle",
            "ruta_url",
            "cerrado_por"
    ];

    setFilteredColumns(
      columnOrder
        .map((id) => columns.find((column) => column.id === id))
        .filter(Boolean)
    );

    } else if (includeRol([ROL_ADMIN])) {
       const columnOrder = [
            "checkbox",
            "periodos",
            "periodo",
            "folio",
            "operador",
            "origen",
            "tipo_compuesto",
            "temporal",
            "estado_resumen",
            "detalle",
            "sobrescribir",
            "ruta_url",
            "cerrado_por"
    ];

    setFilteredColumns(
      columnOrder
        .map((id) => columns.find((column) => column.id === id))
        .filter(Boolean)
    );

    }
  };



  useEffect(() => {
    fetchData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

const applyFilters = (data) => {
  const filterObj = { ...filters };

  if (filterObj.periodo != null) {
    setSelectedPeriodo(filterObj.periodo);
    const newPeriodoData = rows.filter(item =>
      item.periodos?.includes(filterObj.periodo)
    );
    setSelectedPeriodoData(newPeriodoData);
  } else {
    setSelectedPeriodo(null);
    setSelectedPeriodoData([]);
  }

  const newTableData =
    Object.keys(filterObj).length !== 0
      ? data.filter((item) =>
          Object.entries(filterObj).every(([key, val]) =>
            key === "periodo"
              ? item.periodos?.includes(val)  
              : item[key] === val          
          )
        )
      : data;

  if (JSON.stringify(newTableData) !== JSON.stringify(tableData)) {
    setSelected([]); 
  }

  const maxPage = Math.floor((newTableData.length - 1) / rowsPerPage);
  if (page > maxPage) {
    setPage(0);
  }
  setTableData(newTableData);
};

const filterRecords = (name: string, value: any) => {
  const filterObj = { ...filters };
  filterObj[name] = value;

  // Eliminar del objeto si el filtro está vacío
  const isEmpty =
    value === null ||
    (Array.isArray(value) && value.length === 0);

  if (isEmpty) {
    delete filterObj[name];
  }

  // Filtro especial para "periodo"
  if (name === "periodo") {
    setSelectedPeriodo(value);

    const newPeriodoData =
      value != null
        ? rows.filter((item) => item.periodos?.includes(value))
        : [];

    setSelectedPeriodoData(newPeriodoData);
  }

  // Filtrado general con lógica personalizada
  const newTableData =
    Object.keys(filterObj).length !== 0
      ? rows.filter((item) =>
          Object.entries(filterObj).every(([key, val]) => {
            if (key === "periodo") {
              return item.periodos?.includes(val);
            }

            if ((key === "folio" || key === "rbd") && Array.isArray(val)) {
              if(key === "folio"){
                return val.includes(item.folio);
              } else {
                return val.includes(item.rbd);
              }
              
            }

            return item[key] === val;
          })
        )
      : rows;

  if (JSON.stringify(newTableData) !== JSON.stringify(tableData)) {
    setSelected([]);
  }

  const maxPage = Math.floor((newTableData.length - 1) / rowsPerPage);
  if (page > maxPage) {
    setPage(0);
  }

  setFilters(filterObj);
  setTableData(newTableData);
};



    const handleSelectAll = (event) => {
  if (event.target.checked) {
    const newSelecteds = tableData
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map((n) => n.id); // Obtener solo los ids
    setSelected(newSelecteds);
  } else {
    setSelected([]);
  }
};

  const handleCheckboxClick = (index) => {
    const selectedIndex = selected.indexOf(index);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (index) => selected.indexOf(index) !== -1;



  useEffect(() => {
    setPageTitle("Listado de justificaciones de indisponibilidad");
  }, [pageTitle, setPageTitle]);


  function transformData(data) {
  const ROLES = ["MINEDUC", "SUBTEL", "EES"];

  // Asegurar que siempre sea un array simple
  let rawFirmas = data.firmas;
  if (Array.isArray(rawFirmas) && rawFirmas.length === 1 && Array.isArray(rawFirmas[0])) {
    rawFirmas = rawFirmas[0];
  }

  const firmas = Array.isArray(rawFirmas) ? rawFirmas : [];

  const steps = firmas.map((firma) => {
    const rolStr = typeof firma.rol_firma === "string" ? firma.rol_firma : "";
    const inst = ROLES.find((r) => rolStr.includes(r)) || "Contingencia";

    const nombreBase = firma.nombre_firma ?? firma.nombre ?? "";
    const apellido = firma.apellidos_firma ?? "";
    const fullName = apellido ? `${nombreBase} ${apellido}` : nombreBase;

    return {
      type: firma.estado_firma,
      institution: {
        type: inst,
        name: inst,
        rol_firma: firma.rol_firma,
      },
      in_charge: [fullName],
    };
  });

  return {
    ...data,
    firmas: firmas,
    progress: {
      state: data.estado,
      steps,
    },
  };
}

function Row(props) {
  const { row, index } = props;
  const [open, setOpen] = React.useState(false);
  const [firmasRow, setFirmasRow] = React.useState(row.firmas || []);
  const [loadingFirmas, setLoadingFirmas] = React.useState(false);

  const isItemSelected = isSelected(row.id);

  const handleToggle = async () => {
    setOpen((prev) => !prev);

    if (!open && (!firmasRow || firmasRow.length === 0)) {
      setLoadingFirmas(true);
      try {
        const response = await axios.getContingenciaFirma(row.id);
        const newFirmas = response.data || [];

        row.firmas = newFirmas;
        setFirmasRow(newFirmas);
      } catch (error) {
        console.error("Error al obtener firmas:", error);
      } finally {
        setLoadingFirmas(false);
      }
    }
  };

  const transformedRow = React.useMemo(() => {
    return transformData({ ...row, firmas: firmasRow });
  }, [row, firmasRow]);




    return (
      <React.Fragment>
        <TableRow onClick={handleToggle}
          hover
          test_state={row.estado}  test_data={row.id}
          role="checkbox"
          tabIndex={-1}
          key={"TR" + index}
          aria-checked={isItemSelected}
          selected={isItemSelected}
          style={{ paddingBottom: 0, paddingTop: 0 }}
        >

          {filteredColumns  && filteredColumns.map((column, index) => {
            const value = row[column.id];
            return (
              <TableCell key={"TC" + index} align={column.align} 
                        sx={{p: "8px 8px"}}>
                {column.id === "ruta_url" ? (
                  <Button
                  disabled={loadingPDF }
                    onClick={(e) => { e.stopPropagation();
                      downloadPDF(value)
                    }}
                    key={`${column.id}.button.${index}`}
                    variant="text"
                    startIcon={
                      <PictureAsPdfIcon
                        key={`${column.id}.icon.${index}`}
                        sx={{ color: loadingPDF  ? "grey" : "#111" }}
                      />
                    }
                  >
                    <Stack>
                      <Typography
                        key={`${column.id}.typ.${index}`}
                        sx={{
                          color: loadingPDF ? "grey" : "#111",
                          textTransform: "capitalize",
                          textDecoration: "underline",
                        }}
                      >
                        Descargar
                      </Typography>
                    </Stack>
                  </Button>
                ) : column.id === "checkbox" ? (
                                    <Checkbox
                                      color="primary"
                                      checked={isItemSelected}
                                      onClick={() =>
                                        handleCheckboxClick(row.id)
                                      }
                                      inputProps={{
                                        "aria-labelledby": row.id,
                                      }}
                                    />
                                  ) : column.id==="detalle" ? (
                  <Button
                    onClick={(e) => { 
                      e.stopPropagation();
                      
                      window.open("/contingencias_detalle/"+row["id"], "_blank");
                    }}
                    key={`${column.id}.button.${index}`}
                    variant="text"
                  >
                    <Typography
                      key={`${column.id}.typ.${index}`}
                      sx={{
                        color: "#111",
                        textTransform: "capitalize",
                        textDecoration: "underline",
                      }}
                    >
                      Ver
                    </Typography>
                  </Button>
                ) : column.id==="sobrescribir" ? (
                  <Button
                    onClick={(e) => { 
                      e.stopPropagation();
                      window.open("/contingencias_overwrite/"+row["id"], "_blank");
                    }}
                    key={`${column.id}.button.${index}`}
                    variant="text"
                  >
                    <Typography
                      key={`${column.id}.typ.${index}`}
                      sx={{
                        color: "#111",
                        textTransform: "capitalize",
                        textDecoration: "underline",
                      }}
                    >
                      Recrear
                    </Typography>
                  </Button>
                ) : column.id.startsWith("firma") && (row["estado_resumen"] !== REJECTED && row["estado_resumen"] !== APROVED) ? ( 

                <PageButtonBlack
                    width="10rem"
                    loading={!row["puede_firmar"]}
                    pad="0 1rem"
                    onClick={(e) => { 
                      e.stopPropagation();
                      window.open("/contingencias_firma/"+row["id"], "_blank");
                    }}
                  >
                    { getSignatureText(row['estado']) }
                  </PageButtonBlack>
                ) : column.id === "revisar" ? (
                      row["puede_firmar"] ? (
                        <PageButtonBlack
                          width="100%"
                          pad="0 1rem"
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open("/contingencias_firma/" + row["id"], "_blank");
                          }}
                        >
                          Firmar
                        </PageButtonBlack>
                      ) : (
                        <PageButtonWhite
                          width="100%"
                          pad="0 1rem"
                          onClick={(e) => {
                            e.stopPropagation();

                            const baseUrl =
                              row["estado_resumen"] === REJECTED || row["estado_resumen"] === APROVED
                                ? "/contingencias_detalle/"
                                : "/contingencias_rechazar/";

                            window.open(baseUrl + row["id"], "_blank");
                          }}
                        >
                          Entrar
                        </PageButtonWhite>
                      )
                    )

                : column.id === "revisar_mineduc" ? (
                      row["puede_firmar"] ? (
                        <PageButtonBlack
                          width="100%"
                          pad="0 1rem"
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open("/contingencias_firma/" + row["id"], "_blank");
                          }}
                        >
                          Firmar
                        </PageButtonBlack>
                      ) : (
                        <PageButtonWhite
                          width="100%"
                          pad="0 1rem"
                          onClick={(e) => {
                            e.stopPropagation();

                            const baseUrl =
                              row["estado_resumen"] === REJECTED || row["estado_resumen"] === APROVED
                                ? "/contingencias_detalle/"
                                : "/contingencias_rechazar/";

                            window.open(baseUrl + row["id"], "_blank");
                          }}
                        >
                          Entrar
                        </PageButtonWhite>
                      )
                    )

                :  column.id === "revisar_no_sub" ? (
                      row["puede_firmar"] ? (
                        <PageButtonBlack
                          width="100%"
                          pad="0 1rem"
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open("/contingencias_firma/" + row["id"], "_blank");
                          }}
                        >
                          Firmar
                        </PageButtonBlack>
                      ) : (
                        <PageButtonWhite
                          width="100%"
                          pad="0 1rem"
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open("/contingencias_detalle/" + row["id"], "_blank");
                          }}
                        >
                          Entrar
                        </PageButtonWhite>
                      )
                    )

                :

                column.id === 'estado_resumen' ? (
                
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      flexWrap: 'no-wrap',
                    }}>
                      <FiberManualRecordIcon sx={{ fontSize: "0.75rem", color: value === 'En Proceso' ? '#FFE263' : value === APROVED ? '#41AE43' : '#FB3B3B' , marginRight: "0.5rem" }} />

                      {value}
                      <Box sx={{ flexGrow: 1 }} />
                      {value !== 'En Proceso' ? null : open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                    </div>

                )
                : column.id === 'periodos' ? (
                
                    formatPeriodos(value)

                )
                :
                 (
                  value
                )}

                
              </TableCell>
            );
          })}
        </TableRow>
        {row["estado_resumen"] === "En Proceso" ? (
          <TableRow key={row.code + 1}>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                 {loadingFirmas ? (
                  <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100px',
                height: '20vh',
                width: '100%',
                backgroundColor: 'white'
              }}
            >
              <CircularProgress />
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Cargando Firmas...
              </Typography>
            </Box>
                ) : (
                  <ListStepper
                    row={transformedRow}
                    source="Contingencias"
                    formData={row}
                  />
                )}
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }

  return (
    <PageBody>
      <Box width="100%">
<Grid
  container
  spacing={1}
  sx={{ marginBottom: "28px", marginTop: "-2rem" }}
  alignItems="flex-start" // <- evita que los elementos se estiren en vertical
>
  {/* Filtros agrupados */}
  <Grid size={6}>
    <Grid container spacing={1}>
      <Grid size={6}>
        <InputFilter
          data={periodoAfectacionData}
          item={"periodo"}
          name={"Periodo Afectación"}
          callback={filterRecords}
          sortDesc
        />
      </Grid>
      <Grid size={6}>
        <InputFilter
          data={rows}
          item={"periodo_creacion"}
          name={"Periodo creación"}
          callback={filterRecords}
          sortDesc
        />
      </Grid>

      {includeRol([
        ROL_MINEDUC_ADMIN,
        ROL_REP_EES,
        ROL_REP_EES_TEMP,
        ROL_CON_MINEDUC,
        ROL_VAL_SUBTEL,
        ROL_ADMIN,
        ROL_ADMIN_SUBTEL
      ]) && (
        <Grid size={6}>
          <InputFilter
            data={rows}
            item={"operador"}
            name={"Operador"}
            callback={filterRecords}
          />
        </Grid>
      )}

      {(includeRol([
        ROL_MINEDUC_ADMIN,
        ROL_OP_ADMIN,
        ROL_CON_MINEDUC,
        ROL_VAL_SUBTEL,
        ROL_ADMIN,
        ROL_ADMIN_SUBTEL
      ]) && false) && (
        <Grid size={6}>
          <InputFilter
            data={rows}
            item={"origen"}
            name={"Origen"}
            callback={filterRecords}
          />
        </Grid>
      )}

      <Grid size={6}>
        <InputFilter
          data={rows}
          item={"tipo_compuesto"}
          name={"Tipo"}
          callback={filterRecords}
        />
      </Grid>

      <Grid size={6}>
        <InputFilter
          data={rows}
          item={"estado"}
          name={"Estado"}
          defaultOpt={['Aprobado', 'Falta Firma EES', 'Falta Firma EES Temporal', 'Falta firma SUBTEL', 'Falta firma MINEDUC', 'Rechazado']}
          callback={filterRecords}
        />
      </Grid>


      {(includeRol([
        ROL_MINEDUC_ADMIN,
        ROL_OP_ADMIN,
        ROL_CON_MINEDUC,
        ROL_VAL_SUBTEL,
        ROL_ADMIN,
        ROL_ADMIN_SUBTEL
      ])) && (
        <Grid size={6}>
          <InputFilter
            data={rows}
            item={"cerrado_por"}
            name={"Cerrado por"}
            callback={filterRecords}
          />
        </Grid>
      )}
              { includeRol([
        ROL_MINEDUC_ADMIN,
        ROL_CON_MINEDUC,
        ROL_ADMIN
      ]) && ( <Grid size={6}>
        <InputFilter
          data={rows}
          item={"temporal"}
          name={"Representante Temporal"}
          callback={filterRecords}
        />
      </Grid>
    )
  }
    </Grid>
  </Grid>

  {/* InputChipSelect independiente */}
  <Grid container size={6} spacing={0}>
  <Grid size={12} >
    <InputChipSelect
      data={rows}
      item={"folio"}
      name={"ID folio"}
      callback={filterRecords}
    />

  </Grid>

  { includeRol([
        ROL_MINEDUC_ADMIN,
        ROL_CON_MINEDUC,
        ROL_VAL_SUBTEL,
        ROL_ADMIN
      ]) && (<Grid size={12}>
    <InputChipSelect
      data={rows}
      item={"rbd"}
      name={"RBD"}
      callback={filterRecords}
    />
  </Grid>)


  }
    
  </Grid>

</Grid>



        <Paper
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "center",
            background: "#FFFFFF",
            borderRadius: "0.25rem",
            marginBottom: "0.75rem",
          }}
        >
          <Typography
            variant="h1"
            color="inherit"
            noWrap
            sx={{ textAlign: "center", padding: "0.5rem" }}
          >
            LISTADO JUSTIFICACIONES DE INDISPONIBILIDAD
          </Typography>
        </Paper>


        {loadingTable ?
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh',
                width: '100%',
                backgroundColor: 'white'
              }}
            >
              <CircularProgress />
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Cargando...
              </Typography>
            </Box>
            :
          <>
        <PageBgBlock pad="0">
          <Paper
            sx={{
              alignItems: "center",
              width: "100%",
              justifyContent: "center",
              background: "#FFFFFF",
              borderRadius: "0.25rem",
              marginBottom: "0.75rem",
            }}
          >
            <TableContainer>
              <Table size="small" aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {filteredColumns.map((column, index) => (
                      <TableCell
                        key={"CL" + index}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        
                      >
                        {column.id === "checkbox" ? (
                            <Box display="flex" alignItems="center">
                              <Checkbox
                                color="primary"
                                indeterminate={
                                  selected.length > 0
                                }
                                checked={
                                  selected.length > 0 
                                }
                                onChange={handleSelectAll}

                                inputProps={{ "aria-label": "select all" }}
                              />

                              {column.label}
                            </Box>
                          ) : (
                            column.label
                          )}

                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <Row key={index} row={row} index={index} />
                    ))}
                </TableBody>
              </Table>
                    {tableData.length === 0 ? (<ListEmpty></ListEmpty>) : null}
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={tableData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>




        </PageBgBlock>
{includeRol([ROL_VAL_SUBTEL, ROL_ADMIN, ROL_ADMIN_SUBTEL, ROL_MINEDUC_ADMIN]) ? (
  <Grid container spacing={2} columns={9}>

    <Grid size={2}>
      <PageButtonBlack
        loading={downloadLoader || !hasActionableSelection}
        onClick={(e) => {e.preventDefault(); handleOpen("Rechazar")}}
        width="100%"
      >
        Rechazar masivamente
      </PageButtonBlack>
    </Grid>
    <Grid size={2}>
      <PageButtonBlack
        loading={downloadLoader || !hasActionableSelection}
        onClick={(e) => {e.preventDefault(); handleOpen("Aprobar")}}
        width="100%"
      >
        Aprobar masivamente
      </PageButtonBlack>
    </Grid>

    <Grid size={2}>
      <PageButtonWhite
        loading={selectedPeriodoData.length === 0}
        onClick={downloadXLS}
        width="100%"
      >
        Descarga .xlsx periodo: {selectedPeriodo || "-"}
      </PageButtonWhite>
    </Grid>

    <Grid size={3}>
      <PageButtonWhite
        loading={downloadLoader || selected.length === 0}
        onClick={downloadZip}
        width="100%"
      >
        Descarga selección de documentos (.zip)
      </PageButtonWhite>
    </Grid>
  </Grid>
) : (
  <Grid container spacing={1}>
    {/* Si querías un espacio vacío o margen con size={3}, podrías hacer: */}
    <Grid size={3} />

    <Grid size={4}>
      <PageButtonWhite
        loading={selectedPeriodoData.length === 0}
        onClick={downloadXLS}
        width="100%"
      >
        Descarga .xlsx periodo: {selectedPeriodo || "-"}
      </PageButtonWhite>
    </Grid>

    <Grid size={5}>
      <PageButtonWhite
        loading={downloadLoader || selected.length === 0}
        onClick={downloadZip}
        width="100%"
      >
        Descarga selección de documentos (.zip)
      </PageButtonWhite>
    </Grid>
  </Grid>
)}

          </>

          }
       
      </Box>

        <ModalMassive
          open={open}
          btnText="Ir al listado"
          selected={selected}
          action={action}
          onClick={() => navigate("/contingencias_lista")}
          onClose={handleClose}
        ></ModalMassive>

    </PageBody>
  );
}
